import React from 'react';
import PropTypes from "prop-types"
import styled from 'styled-components';
import Icon  from '../icons/icon';

const StyledSocialList = styled.ul`
  display: flex;
  flex-direction: initial;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    a {
      padding: 10px;
      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`;

const getHostname = url => {
  return new URL(url.toLowerCase()).hostname.replace(/www|com|net|\.so|org|[.-]/g, '').split('.')[0];
};

const getServicename = url => {
  return url.toLowerCase().split(':')[0];
};


const Social = ({social}) => {

return(
    <StyledSocialList>
      {social.map((item, i) => {
        const name = item.name || getHostname(item.url) || getServicename(item.url);

          return (
            <li key={i}>
              <a href={item.url} aria-label={name} target="_blank" rel="noopener noreferrer">
                <Icon name={name}/>
              </a>
            </li>
          )
        })
      }
    </StyledSocialList>
  );
};

Social.propTypes = {
  social: PropTypes.array.isRequired
};

export default Social;
